export default __webpack_public_path__ + "static/media/smartwatch.991b4662.png";